import React from "react";
import { ModeRendererProps } from "./types";

export function CodeRainMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {Array.from({ length: 28 }).map((_, col) => {
        const lines = Array.from({ length: 32 }).map(() =>
          Array.from({ length: 2 })
            .map(() => (Math.random() > 0.5 ? "1" : "0"))
            .join("")
        );
        return (
          <g key={col}>
            {lines.map((line, lineIdx) => (
              <text
                key={`${col}-${lineIdx}`}
                x={20 + col * 26}
                y={20 + lineIdx * 14}
                fontFamily="monospace"
                fontSize="11"
                fill={brand.green}
                opacity={0.8 - lineIdx * 0.015}
              >
                {line}
              </text>
            ))}
          </g>
        );
      })}
    </g>
  );
}
